import { format } from 'date-fns-jalali';
import T from '../text';
import { getDayPeriod, local } from './date-helper';
import { Stack, Typography } from '@mui/material';

export const DateInput = ({ value, fontSize }) => {
  if (!value) return <T>null</T>;

  const date = new Date(value);

  return <T fontSize={fontSize}>{format(date, 'yyyy/MM/dd', { local })}</T>;
};
export const DateTimeInput = ({ value, fontSize }) => {
  if (!value) return <T>null</T>;

  const date = new Date(value);

  return (
    <Stack flex flexDirection="row" alignItems="center" gap={1}>
      <T fontSize={fontSize}>{format(date, 'yyyy/MM/dd hh:mm', { local })}</T>
      <Typography sx={{ fontSize: 12, whiteSpace: 'nowrap' }}>{getDayPeriod(date)}</Typography>
    </Stack>
  );
};

export const UpdatedAt = ({ value }) => {
  if (!value)
    return (
      <T
        sx={{
          whiteSpace: 'nowrap',
          color: 'text.disabled',
        }}
      >
        no-change-recorded
      </T>
    );

  return <DateTimeInput value={value} />;
};

export const CreatedAt = ({ value }) => <DateTimeInput value={value} />;
